var vluxTags = [
    {
        tagName: 'b red',
        element: {
            startTag: '<span class="vfeo-bold red" style="font-weight: 600;color: #e60000">',
            endTag: '</span>'
        }
    },
    {
        tagName: 'box',
        element: {
            startTag: '<span class="vfeo-box" style="display:block;margin-bottom:5px;"><span style="display:inline-block;background:#e60000;padding: 5px 10px;color:#FFFFFF;">',
            endTag: '</span></span>'
        }
    },
    {
        tagName: 'eur',
        element: {
            startTag: '&euro;',
            endTag: ''
        }
    }
];
var VluxMarkupFramework = /*@__PURE__*/ (function () {
    function VluxMarkupFramework() {
    }
    VluxMarkupFramework.parse = function (value, disableMargin, nowrap) {
        var containerStart = "<div style=\"margin-bottom: " + (disableMargin ? 0 : 15) + "px;\">";
        var containerEnd = '</div>';
        if (nowrap) {
            containerStart = '';
            containerEnd = '';
        }
        value = "" + containerStart + value;
        for (var _i = 0, vluxTags_1 = vluxTags; _i < vluxTags_1.length; _i++) {
            var markup = vluxTags_1[_i];
            var matchStartingTag = "" + VluxMarkupFramework.TAG_START + markup.tagName + VluxMarkupFramework.TAG_END;
            var matchEndingTag = "" + VluxMarkupFramework.CLOSING_TAG_START + markup.tagName + VluxMarkupFramework.CLOSING_TAG_END;
            var resultingStartingTag = markup.element.startTag;
            var resultingEndingTag = markup.element.endTag;
            value = value.replace(new RegExp(matchStartingTag, 'g'), resultingStartingTag);
            value = value.replace(new RegExp(matchEndingTag, 'g'), resultingEndingTag);
        }
        value += containerEnd;
        return value;
    };
    VluxMarkupFramework.TAG_START = '{';
    VluxMarkupFramework.TAG_END = '}';
    VluxMarkupFramework.CLOSING_TAG_START = '{/';
    VluxMarkupFramework.CLOSING_TAG_END = '}';
    return VluxMarkupFramework;
}());
export { VluxMarkupFramework };
export function VluxMarkup(value, disableMargin, nowrap) {
    if (typeof value === 'string') {
        return VluxMarkupFramework.parse(value, disableMargin, nowrap);
    }
    return VluxMarkupFramework.parse(value.join(''), disableMargin, nowrap);
}



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/utils/vlux-markup.ts
// module id = crMA
// module chunks = 0 2